import {
  RequrstBack,
  queryInitStatClientConfig,
} from '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/hooks';
import http from '@/utils/http';
import { useRequest } from 'ahooks';
import { useParams } from 'umi';

export const useGetGlobalSizePlayerSummary = <T>(params: T, changeValue: string) => {
  // url变化，这里将会重新redner
  const active = useParams() as any;
  const url = {
    revenue: '/api/v1/intelligence_pc/globalView/marketSize/revenue/summary',
    players: '/api/v1/intelligence_pc/globalView/marketSize/players/summary',
  }[active.tab as string];

  const fetch = (mutateParams: T) => {
    // 如果时间为空，不发出请求，只返回空
    if (!changeValue) {
      return Promise.resolve({
        data: null, code: 0, msg: '', req: {},
      });
    }

    return http({
      url,
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  }
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'playerSummary',
    manual: false,
    loadingDelay: 0,
  });
  return {
    ...data,
  };
};

export const useGrowthDetails = <T>(params: T, changeValue: string) => {
  // url变化，这里将会重新redner
  const active = useParams() as any;
  const url = {
    revenue: '/api/v1/intelligence_pc/globalView/marketSize/revenue/revenueMap',
    players: '/api/v1/intelligence_pc/globalView/marketSize/players/playerMap',
  }[active.tab as string];
  const fetch = (mutateParams: T) => {
    // 如果时间为空，不发出请求，只返回空
    if (!changeValue) {
      return Promise.resolve({
        data: null, code: 0, msg: '', req: {},
      });
    }
    return http({
      url,
      method: 'post',
      data: params,
      ...mutateParams,
    }) as RequrstBack;
  }
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    ready: !!params,
    cacheKey: 'growthDetails',
    manual: false,
    loadingDelay: 0,
  });
  return {
    ...data,
  };
};
//
export function downloadMarSizeData(params: any) {
  return http('/api/v1/intelligence_pc/cos/downloads_excel', {
    method: 'post',
    data: params,
    responseType: 'arraybuffer',
    rawData: true,
    httpResponses: true,
  });
}
